import { translate } from '~l10n/client';

import { toast } from '~shared/components/Toast';

import { QuizToastActions } from '.';

export const handleToastSuccess = (
  items: (string | number)[],
  action: string
) => {
  switch (action) {
    case QuizToastActions.MERGE: {
      return toast(translate('Successfully merged into {0}').format(items[0]), {
        tone: 'positive',
      });
    }
    case QuizToastActions.RESTORE: {
      if (items.length === 0 || items.length === 1) {
        return toast(translate('1 item restored to Library'), {
          tone: 'positive',
        });
      }
      return toast(
        translate('{0} items restored to Library').format(items.length),
        {
          tone: 'positive',
        }
      );
    }
    case QuizToastActions.CREATE_QUIZ: {
      return toast(translate('Quiz successfully created'), {
        tone: 'positive',
      });
    }
    case QuizToastActions.COPY: {
      return toast(translate('Creating duplicate').format(items[0], items[1]), {
        tone: 'positive',
      });
    }
    case QuizToastActions.IMPORT: {
      return toast(translate('Imported'), {
        tone: 'positive',
      });
    }
  }
};
